import React from 'react';
import { useNavigate } from 'react-router-dom';
import LayoutHeader from '../../layout/LayoutHeader';

const FlowsCreate = () => {
  const navigate = useNavigate();

  return (
    <LayoutHeader>
      <div className="flex justify-center w-full">
        <div className="w-[390px] h-[80vh] flex flex-col items-center relative z-[0]">
          {/* Header */}
          <div className="px-4 my-[50px] flex w-full justify-between">
            <span className="text-white text-[14px]" style={{ fontWeight: 300 }}>Create Workflow</span>
            <div className="flex items-center gap-4">
              <span 
                className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70" 
                onClick={() => navigate('/flows')}
              >
                Go back
              </span>
            </div>
          </div>

          <div className="w-full px-4 flex-1 overflow-y-auto">
            {/* Action Buttons */}
            <div className="flex flex-col gap-4 mb-8">
              <div
                onClick={() => navigate('/flows/create-workflow')}
                className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#FF3B30] hover:bg-[rgba(255,59,48,0.05)] transition-all cursor-pointer"
              >
                <h3 className="text-white text-[12px] font-normal mb-2">Create Custom Workflow</h3>
                <p className="text-[rgba(255,255,255,0.7)] text-[11px] leading-[1.5]">
                  Build your own workflow from scratch with custom steps and timing
                </p>
              </div>

              <div
                onClick={() => navigate('/flows/song-release')}
                className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#FF3B30] hover:bg-[rgba(255,59,48,0.05)] transition-all cursor-pointer"
              >
                <h3 className="text-white text-[12px] font-normal mb-2">Song Release</h3>
                <p className="text-[rgba(255,255,255,0.7)] text-[11px] leading-[1.5]">
                  Pre-configured workflow for music releases with steps for distribution, pitching, and post-release tracking
                </p>
              </div>

              <div
                onClick={() => navigate('/flows/upcoming-show')}
                className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#FF3B30] hover:bg-[rgba(255,59,48,0.05)] transition-all cursor-pointer"
              >
                <h3 className="text-white text-[12px] font-normal mb-2">Upcoming Show</h3>
                <p className="text-[rgba(255,255,255,0.7)] text-[11px] leading-[1.5]">
                  Pre-configured workflow for live shows with steps for booking, advance, travel, and settlement
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutHeader>
  );
};

export default FlowsCreate;

